import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoArbitrato } from '../../../../common/models/tipologiche/tipo-arbitrato';

export class FascicoloArbitrato extends FascicoloFull {
  tipoArbitrato: TipoArbitrato;
  collegioArbitrale: boolean;
  dataRichiestaArbitrato: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
